import { FormControl, Grid, makeStyles } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { keyBy as _keyBy, compact as _compact, map as _map } from 'lodash';
import { useSelector } from 'react-redux';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@material-ui/icons/Close';
import CustomMultiSelectAll from '../../shared/CustomMultiSelectAll';
import useFetchDetails from '../hooks/useFetchDetails';
import { ErrorToast } from '../../utils/Utils';
import ReactDnD from '../../common/ReactDnD';

const useStyles = makeStyles((theme) => ({
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  cardContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '8px',
    padding: '16px',
    marginTop: '16px',
    backgroundColor: '#FFFFFF',
    position: 'relative',
    overflow: 'visible',
  },
}));

const PreferedBrands = ({ data, handleDataChange }) => {
  const classes = useStyles();
  const rnpSectionRef = useRef(null);
  const { fetchRnpList } = useFetchDetails();

  const rnpList = useSelector((state) => state.rnpData.rnpList);

  const [rnpDataList, setRnpDataList] = useState([]);
  const [dndData, setDndData] = useState([]);
  const [, setModifiedOrderIds] = useState([]);

  useEffect(() => {
    fetchRnpList();
    const idToLabelMap = _keyBy(rnpOptions, 'id');
    const tempList = _map(data?.preferredBrands, (id) => idToLabelMap[id]);
    const cleanedData = _compact(tempList);
    setDndData(cleanedData);
    setRnpDataList(cleanedData);
  }, []);

  const rnpOptions = React.useMemo(() => {
    if (!rnpList) return [];
    return rnpList
      .filter((item) => item.type !== 'ROCKED')
      .flatMap((item) => item.partners)
      .map((p) => ({
        label: p.name,
        value: p.id,
        icon: p.icon,
        id: p.id,
      }));
  }, [rnpList]);

  const handleRnpClick = () => {
    setTimeout(() => {
      rnpSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  const handleRnpSelect = (selected) => {
    if (selected.length > 5) {
      ErrorToast('You can select a maximum of 5 RNP/OEMs');
      return;
    }
    setRnpDataList(selected);
    const tempList = selected.map((item) => item.id);
    handleDataChange({ target: { name: 'preferredBrands', value: tempList } });
  };

  const handleDndUpdate = (updated) => {
    setDndData(updated);
    setRnpDataList(updated);
    const tempList = updated.map((item) => item.id);
    handleDataChange({ target: { name: 'preferredBrands', value: tempList } });
  };

  const renderRnpItem = (item, isDragging = false) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#f4f4f4',
        padding: '8px 12px',
        borderRadius: '8px',
        ...(isDragging && {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          transform: 'rotate(2deg)',
        }),
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
        <MenuIcon fontSize="small" />
        <img src={item.icon} alt="" width={30} height={30} />
        <span style={{ fontWeight: 500, fontSize: '12px', color: '#10182B' }}>{item.label}</span>
      </div>

      <div
        style={{
          cursor: 'pointer',
          fontSize: '18px',
          fontWeight: 600,
          background: 'transparent',
          border: 'none',
          padding: 0,
        }}
      >
        <CloseIcon
          onClick={() => {
            const updated = dndData.filter((i) => i.value !== item.value);
            handleDndUpdate(updated);
          }}
          fontSize="small"
        />
      </div>
    </div>
  );

  return (
    <Grid item xs={12} style={{ marginBottom: '20px' }} ref={rnpSectionRef} onClick={handleRnpClick}>
      <div className={classes.cardContainer}>
        <div className={classes.popupLabels}>RNP Content Ordering (optional)</div>

        <FormControl style={{ marginTop: '5px', width: '100%' }}>
          <CustomMultiSelectAll
            width="450px"
            options={rnpOptions}
            selectedOptions={rnpDataList}
            onChange={handleRnpSelect}
            onMenuClose={() => {
              setDndData(rnpDataList);
            }}
            maxMenuHeight={240}
            placeholderButtonLabel="Select RNP(s)"
            getDropdownButtonLabel={({ value }) => {
              if (!value || value.length === 0) {
                return 'Select RNP(s)';
              }
              return `${value.length} selected`;
            }}
          />
          {dndData?.length > 0 && (
            <div style={{ width: '40%', marginTop: '16px', position: 'relative', zIndex: 1, marginBottom: '10px' }}>
              <ReactDnD
                data={dndData}
                setData={handleDndUpdate}
                setModifiedOrderIds={setModifiedOrderIds}
                renderItem={renderRnpItem}
                calledFrom="rnp"
                id="rnpOrderList"
                key="rnpOrderList"
              />
            </div>
          )}
        </FormControl>
      </div>
    </Grid>
  );
};
export default PreferedBrands;
